//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { faCaretDown, faCaretUp, faChevronRight } from '@fortawesome/pro-solid-svg-icons';

export default {
  name: 'LandingCategoryTreeCard',
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      openSubcategoryIds: {},
    };
  },
  computed: {
    faCaretDown() { return faCaretDown; },
    faCaretUp() { return faCaretUp; },
    faChevronRight() { return faChevronRight; },
    categoryUrl() {
      return _.get(this.category, 'url', '');
    },
    imageUrl() {
      return _.get(this.category, 'image.url', '');
    },
    hasItems() {
      return this.category.items && this.category.items.length;
    },
  },
  methods: {
    isOpen(id) {
      return !!this.openSubcategoryIds[id];
    },
    toggle(id) {
      this.$set(this.openSubcategoryIds, id, !this.openSubcategoryIds[id]);
    },
  },
};
